/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/video/video.jwplayer.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'video/jwplayer', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



import { global_consts as global_consts_CookieNames } from '@take-2/fd-modules/splits/require-core';

const { CookieNames } = global_consts_CookieNames;


import { Fandango_cookie as Fandango_cookie_get_getCookie } from '@take-2/fd-modules/splits/require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from '@take-2/fd-modules/splits/require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango as Fandango_pageDetails } from '@take-2/fd-modules/splits/require-core';

const { pageDetails: { isMOP } } = Fandango_pageDetails;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { Fandango as Fandango_account_analyticsData_context_jwPlayerData } from '@take-2/fd-modules/splits/require-core';

const { account: { isLoggedIn } = {}, analyticsData: { customerGUID } = {}, context: { device: { isMobile } }, jwPlayerData: { alternateTitle, autostart, contentURL, duration, freewheelAdManagerVersion, freewheelNetworkID, genre, id, image, mature, title, type, useVersantFreewheelConfig, videoTitle } = {} } = Fandango_account_analyticsData_context_jwPlayerData;


const Classes = {
    AGE_VERIFICATION_CARD: 'age-verification-card',
    AGE_MESSAGING: 'age-messaging',
    AGE_COPY: 'age-copy',
    AGE_INTERACTIVE: 'age-interactive',
    AGE_CTA: 'age-cta'
}


const IDs = {
    USER_AGREES: 'user-agrees',
    USER_DISAGREES: 'user-disagrees'
}


const DataLayerEvents = {
    MEDIA_PLAY: 'media-play',
    MEDIA_ERROR: 'media-error'
}


const JWPlayerEvents = {
    READY: 'ready',
    BEFORE_PLAY: 'beforePlay',
    PLAY_ATTEMPT_FAILED: 'playAttemptFailed',
    PLAY: 'play',
    ERROR: 'error',
    PLAYLIST_COMPLETE: 'playlistComplete',
    FIRST_FRAME: 'firstFrame',
}


const Selectors = {
    JW_CONTROLS: '.jw-controls',
    AGE_VERIFICATION_CARD: `.${Classes.AGE_VERIFICATION_CARD}`,
    USER_AGREES: `#${IDs.USER_AGREES}`,
    USER_DISAGREES: `#${IDs.USER_DISAGREES}`,
    AGE_COPY: `.${Classes.AGE_COPY}`,
    AGE_INTERACTIVE: `.${Classes.AGE_INTERACTIVE}`,
    OFFER_CTA: '.js-offer-cta',
    PLACEHOLDER: '.movie-detail__video'
}


const Text = {
    AGE_VERIFICATION_HEADER: 'Age Verification',
    AGE_VERIFICATION_COPY: 'This content is rated: adult. By clicking YES, I certify that I am 17 or older.',
    YES: 'Yes',
    NO: 'No',
    CONTENT_NOT_PLAYABLE: 'Sorry, this content is not playable.'
}


const CustomEvents = {
    ON_RELEASE_END: 'take2player:OnReleaseEnd',
    ON_MODAL_CLOSE: 'take2player:OnModalClose'
}


let mediaInProgress = false
function triggerAnalyticsEvent(event) {
    parent.dataLayer.push({
        event,
        content: {
            id: `fandango_${id}`,
            length: `${duration}`,
            type: 'vod',
            ['player_name']: 'jw',
            ['sdk_version']: `web: ${window.jwplayer().version.split('+')[0]}`,
            channel: 'movie',
            name: videoTitle?.toLowerCase(),
            rating: mature ? 'adult' : 'not adult',
            ['stream_type']: 'video'
        },
        ['media_parms']: {
            genre: genre?.toLowerCase(),
            ['show_type']: type === 'trailer' ? '1' : '2'
        },
        user: {
            attributes: {
                ['login_status']: isLoggedIn ? 'logged-in' : 'logged-out'
            },
            profile: {
                id: customerGUID
            }
        }
    });
}
function init(fwUserID, opts) {
    if (!window.jwplayer) {
        return debugLog.info(module.name, 'not enabled');
    }
    const { height, width, hideTitle } = opts || {};
    window.jwplayer('fandangoPlayer')
        .setup({
        autostart,
        ...(height && width ? {
            height,
            width
        } : {}),
        playlist: [
            {
                image,
                title: hideTitle ? '' : title,
                sources: [
                    {
                        default: false,
                        type: 'hls',
                        file: `${contentURL}?formats=MPEG-DASH+widevine,M3U+appleHlsEncryption,M3U+none,MPEG-DASH+none,MPEG4,MP3`,
                        label: '0',
                    }
                ],
                floating: {
                    dismissible: true,
                    mode: 'always'
                },
            }
        ],
        fwassetid: `fandango_${id}`,
        advertising: {
            client: 'freewheel',
            vpaidcontrols: true,
            freewheel: {
                networkid: freewheelNetworkID,
                serverid: `https://${useVersantFreewheelConfig ? '82aef' : 29773}.v.fwmrm.net/ad/g/1`,
                profileid: `${freewheelNetworkID}:${useVersantFreewheelConfig ? 'versant' : 'nbcu'}_fandango_web_jwp`,
                sectionid: 'fandango_alldevice_allos_web_ondemand',
                adManagerURL: `https://mssl.fwmrm.net/libs/adm/${freewheelAdManagerVersion}/AdManager.js`,
                afid: useVersantFreewheelConfig ? 440067540 : 140314981,
                vcid: fwUserID,
                sfid: useVersantFreewheelConfig ? 23759206 : (isMobile ? 7232639 : 4732245),
                csid: `fandango_alldevice_allos_web_ondemand${isMobile ? '_hh' : ''}`,
                caid: id,
                resp: 'json',
                metr: 1023,
                vdur: duration,
                capabilities: {
                    flag: {
                        sltp: 'on',
                        emcr: 'on',
                        slcb: 'on',
                        nucr: 'on',
                        sbid: 'on',
                        fbad: 'on',
                        aeti: 'on',
                        slif: 'on',
                        vicb: 'on',
                        amcb: 'on',
                    }
                },
                custom: {
                    _fw_h_referer: document.referrer,
                    _fw_vcid2: fwUserID,
                    _fw_us_privacy: getCookie(CookieNames.CCPA_OPT_OUT_STATUS),
                    _fw_gpp: getCookie(CookieNames.ONETRUST_GPP_CONSENT),
                    _fw_player_width: 1920,
                    _fw_player_height: 1080
                }
            },
            schedule: [
                {
                    tag: 'fw-preroll'
                }
            ]
        },
    })
        .on(JWPlayerEvents.READY, () => {
        $(Selectors.PLACEHOLDER).remove();
        $(Selectors.JW_CONTROLS).after(`
          <div class="${Classes.AGE_VERIFICATION_CARD}">
            <div class="${Classes.AGE_MESSAGING}">
              <h3>${Text.AGE_VERIFICATION_HEADER}</h3>
              <p class="${Classes.AGE_COPY}">${Text.AGE_VERIFICATION_COPY}</p>
              <form class="${Classes.AGE_INTERACTIVE}">
                <button class="${Classes.AGE_CTA}" id="${IDs.USER_AGREES}">${Text.YES}</button>
                <button class="${Classes.AGE_CTA}" id="${IDs.USER_DISAGREES}">${Text.NO}</button>
              </form>
            </div>
          </div>
        `);
        const satellite = window._satellite;
        if (!satellite || typeof satellite.getVar !== 'function') {
            return;
        }
        const comscoreLabelMapping = {
            ns_st_pr: title,
            ns_st_ep: alternateTitle,
            ns_st_st: 'fandango',
            ns_st_pu: 'fandango',
            ns_st_ci: id,
            ns_st_ge: genre,
            cs_ucfr: satellite.getVar('Comscore Consent'),
            c1: '2',
            c2: '40813950',
            c3: 'fandango',
            c4: window.location.href,
            c5: satellite.getVar('Movie ID;'),
            c6: satellite.getVar('Page Level 2'),
            c12: satellite.getVar('com_id'),
        };
        window.ns_.StreamingAnalytics.JWPlayer(window.jwplayer(), {
            publisherId: '40813950',
            labelmapping: Object.entries(comscoreLabelMapping).map(([key, value]) => `${key}="${value}"`).join(',')
        });
    })
        .on(JWPlayerEvents.BEFORE_PLAY, () => {
        if (!mediaInProgress) {
            mediaInProgress = true;
            triggerAnalyticsEvent(DataLayerEvents.MEDIA_PLAY);
            if (isMOP) {
                track(EventTypes.VIDEO_START);
                $(Selectors.OFFER_CTA).remove();
            }
        }
    })
        .on(JWPlayerEvents.PLAY_ATTEMPT_FAILED, () => {
        triggerAnalyticsEvent(DataLayerEvents.MEDIA_ERROR);
    })
        .once(JWPlayerEvents.PLAY, () => {
        if (mature) {
            const ageVerificationCard = $(Selectors.AGE_VERIFICATION_CARD);
            window.jwplayer().pause();
            ageVerificationCard.css('display', 'flex');
            $(Selectors.USER_AGREES).on('click', (event) => {
                ageVerificationCard.hide();
                window.jwplayer().play();
                event.preventDefault();
            });
            $(Selectors.USER_DISAGREES).on('click', (event) => {
                $(Selectors.AGE_COPY).html(Text.CONTENT_NOT_PLAYABLE);
                $(Selectors.AGE_INTERACTIVE).hide();
                event.preventDefault();
            });
        }
        window.jwplayer().setCurrentCaptions(0);
    })
        .on(JWPlayerEvents.ERROR, () => {
        triggerAnalyticsEvent(DataLayerEvents.MEDIA_ERROR);
    })
        .on(JWPlayerEvents.PLAYLIST_COMPLETE, () => {
        mediaInProgress = false;
        parent.postMessage({
            name: CustomEvents.ON_RELEASE_END,
            video: { videoID: id }
        }, '*');
    })
        .on(JWPlayerEvents.FIRST_FRAME, () => {
        window.jwplayer().setCurrentCaptions(0);
    })
        .setCurrentCaptions(0);
    parent.addEventListener(CustomEvents.ON_MODAL_CLOSE, (e) => {
        if (e.detail.src === window.location.href) {
            window.jwplayer().remove();
        }
    });
    parent.jwplayer = window.jwplayer;
    window.safari = parent.safari;
}
export default {
    init,
};
